module.exports = __webpack_public_path__ + "img/Social.137e5e43.svg";